import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectAppConfig } from 'store/app/app.selectors'
import AfterCallWorkView from './afterCallWork'
import './afterCallWork.scss'

type Props = {
    completeCallACW: () => void
}

const AfterCallWork: React.FC<Props> = ({ completeCallACW }) => {
    const appConfig = useSelector(selectAppConfig)

    const handleTimeout = useCallback(() => {
        completeCallACW()
    }, [completeCallACW])

    return (
        <AfterCallWorkView
            appConfig={appConfig}
            onTimeout={handleTimeout}
        />
    )
}

export default AfterCallWork
